import React from "react";
import { ENTRIES } from "../shared/assets/entry_data";
import { GOLFERS } from "../shared/assets/golfer_data";
import { PAYOUTS } from "../shared/assets/payouts";

function getPositionFull(golfer) {
    // let position = GOLFERS.filter((obj) => obj.name === golfer)[0].position;
    let position = GOLFERS.filter((obj) => obj.name === golfer)[0].position;
    let posQualifier = GOLFERS.filter((obj) => obj.name === golfer)[0].posQualifier;
    let curPos="";
    if (posQualifier === "T" || posQualifier === "") {
        curPos = posQualifier + position;
    } else {
        curPos = posQualifier;
    }
    return curPos;
}
function entryComparator(a, b) {
    return a.name.localeCompare(b.name)
}

function getPositionNum(golfer) {
    let position = GOLFERS.filter((obj) => obj.name === golfer)[0].position;
    let posQualifier = GOLFERS.filter((obj) => obj.name === golfer)[0].posQualifier;
    let curPosNum=0;
    if (posQualifier === "MC" || posQualifier === "DQ") {
        curPosNum = 55;
    } else {
        curPosNum = position;
    }
    return curPosNum;
}
function getCurScore(golfer) {
    let curScore = GOLFERS.filter((obj) => obj.name === golfer)[0].curScore;
    return curScore;
}
function getPlayerWinnings(golfer, isFinal) {
    let winnings = 0
    if (isFinal)
        winnings = GOLFERS.filter((obj) => obj.name === golfer)[0].winnings;
    else
        winnings = PAYOUTS[GOLFERS.filter((obj) => obj.name === golfer)[0].position-1];
    // console.log("golfer: " + golfer + " " + winnings)
    return winnings;
}
function Entries() {
    const isFinal = true
    ENTRIES.sort(entryComparator);
    const entries = ENTRIES.map((entry) => {
        let golfers=[];
        let totPos=0;
        let totWinnings=0;
        var formatter = new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
            minimumFractionDigits: 0,
        });
        for (var i = 0; i<entry.golfers.length; i++) {
            // golfers[i] = entry.golfers[i] + ' (' + getPositionFull(entry.golfers[i]) + ')';
            let playerPos = getPositionFull(entry.golfers[i])
            let playerWinnings = getPlayerWinnings(entry.golfers[i], isFinal); 
            totWinnings += playerWinnings;
            // golfers[i] = entry.golfers[i] + ' (' + getCurScore(entry.golfers[i]) + ') ' + formatter.format(playerWinnings)
            golfers[i] = entry.golfers[i] + ' - ' + formatter.format(playerWinnings)
            // golfers[i] = entry.golfers[i] + ' (' + getCurScore(entry.golfers[i]) + ') ' + playerPos
            totPos += getPositionNum(entry.golfers[i]);
        }
        let avgPos = totPos / 5;
        let dollars = formatter.format(totWinnings);
        return(
            <div key={entry.name} id={entry.name}>
                <div className="m-5 w-64 shadow-2xl bg-gray-300 rounded-lg" key={entry.name}>
                    <div className="p-2 flex flex-col items-start">
                        <p className="text-2xl">{entry.name}</p>
                        <p className="text-base leading-9">Tot Winnings: {dollars}</p>
                        <p className="text-base leading-9">Avg Pos: {avgPos}</p>
                        <p className="text-sm">{golfers[0]}</p>
                        <p className="text-sm">{golfers[1]}</p>
                        <p className="text-sm">{golfers[2]}</p>
                        <p className="text-sm">{golfers[3]}</p>
                        <p className="text-sm">{golfers[4]}</p>
                        <p className="text-sm leading-9">Tie-breaker: {entry.tiebreaker}</p>
                    </div>
                </div>
            </div>
        );
    });
    return (
        <div className="mt-20">
            <p className="text-3xl mt-6 py-2 bg-masters-green masters-label">Entries</p>
            {/* <p className="text-3xl mt-20 mb-4">Entries</p> */}
            {/* <p className="text-3xl mb-4 masters-label">Entries</p> */}
            <div className="flex flex-row flex-wrap justify-center mb-6">{entries}</div>
        </div>
    );
}

export default Entries;